import { generateRandomString, sha256Base64Url } from "./Pkce.js";


const clientId = "836ddfe846db4100acfa820a024f15e2";
const redirectUri = "https://playlistmanager.10cats.com/playlists";

export async function startSpotifyLogin(scopes) {
  const verifier = generateRandomString(64);
  const challenge = await sha256Base64Url(verifier);

  sessionStorage.setItem("spotify_pkce_verifier", verifier);

  const params = new URLSearchParams({
    client_id: clientId,
    response_type: "code",
    redirect_uri: redirectUri,
    scope: scopes.join(" "),
    code_challenge_method: "S256",
    code_challenge: challenge,
  });

  window.location.href =
    "https://accounts.spotify.com/authorize?" + params.toString();
}